import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';
import { Typography } from '@material-ui/core';

export const MessagesContainer = styled.div``;

export const MessageContainer = styled.div`
  margin-bottom: 10px;
  padding-bottom: 5px;
`;

const SapMessages = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const { messages, blocking, exportToSap } = modalProps;

  const handleContinue = () => {
    exportToSap();
  };

  return (
    <>
      <Modal.Header title={t('sap_messages_title')} />
      <Modal.Content>
        <MessagesContainer>
          {messages.map((message: string, i: number) => {
            return (
              <MessageContainer key={i}>
                <Typography>{utils.app.textTranslated(message, t)}</Typography>
              </MessageContainer>
            );
          })}
        </MessagesContainer>
      </Modal.Content>
      <Modal.Footer
        withConfirmButton={!blocking}
        confirmText={!blocking ? t('continua') : undefined}
        confirmAction={!blocking ? handleContinue : undefined}
        closeButtonText={t('chiudi')}
      />
    </>
  );
};

export default SapMessages;
